finderApp.directive('niFinderNavigation', ['$window', function ($window) {
    return {
        controller: 'navigation',
        link: function(scope, element, attr) {
            var affixContainer = element.find('.finder-categories-sub-container'),
                affixHelper = element.find('.fix-affix-helper');

            // init affix
            affixContainer.affix({
                offset: {
                    top: affixContainer.offset().top
                }
            });

            function recalculateSubnavHeight() {
                affixContainer.data('bs.affix').options.offset.top = affixContainer.offset().top;
                //affixContainer.affix('checkPosition');
                affixHelper.data('containerHeight', affixContainer.outerHeight(true));
            }

            function setHeight(fix) {
                if (fix === true || jQuery(affixContainer).css('position') === 'fixed') {
                    affixHelper.height(affixHelper.data('containerHeight'));
                } else {
                    affixHelper.height('auto');
                }
            }

            scope.$on('categoryInfoRefreshed', recalculateSubnavHeight);
            angular.element($window).bind('resize', recalculateSubnavHeight);

            angular.element($window).bind('scroll', setHeight);
            affixContainer.bind('affix.bs.affix', setHeight.bind(this, true));

        }
    };
}]);